<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	import Vue from 'vue';
	
    // 本地存储
    import {getSessionStorage} from "@/utils/cookie.js";
    import {getLocalStorage, getStorage} from "./utils/cookie";

    export default {
        name: "app",
        provide() {
            return {
                app: this
            };
        },
        data() {
            return {
                // 试卷状态
				// 预览状态 0  显示分数  preview
				// 考前状态 1  exam
				// 考试状态 2  exam
				// 学生查阅状态、考试结束状态 3  exam
                // 教师查阅状态 4  submit
				status: null,
				
				// 试卷
				paper: null,
				
				// 提交
				submit: null,

                // 学生填写的答案列表
                submits: null,

                // 表单状态，控制前端表单是否可以输入
                disabled: false,

                // 显示试卷
				showPaper: true,
				
                // 显示作答状态
				showSubmits: true,
				
                // 显示作答是否正确
                showErrors: false,
				
                // 显示正确答案
                showAnswers: false,
				
				// 显示分数
				showScore: false,

                isLogin: Vue.permanentAuth ? !!getLocalStorage("token") : !!getStorage("token")
            };
        },
        // mounted() {
        //     console.log('App.vue mounted')
        // },
        methods: {}
    };
</script>

<style lang="scss">
	@import "./assets/css/style.css";
</style>